export default{
    
    lista:{
        method:'get',
        url:'cbo/lista'
    },
    cadastra:{
        method:'post',
        url:'cbo/cadastro'
    },
    delete:{
        method:'delete',
        url:'cbo/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'cbo/editar{/id}'
    },
    update:{
        method:'post',
        url:'cbo/update'
    },
    pesquisa:{
        method:'get',
        url:'cbo/busca{/id}'
    }
}